import {faInbox} from "@fortawesome/pro-solid-svg-icons/faInbox";
import {faLock} from "@fortawesome/pro-solid-svg-icons/faLock";
import {faShare} from "@fortawesome/pro-solid-svg-icons/faShare";
import {useClientAccountOverview} from "@twigsby/client-data";
import {ColourSolid, Tile} from "@twigsby/frontend-framework";
import React from "react";
import {useTranslation} from "@twigsby/frontend-framework";
import {useNavigate} from "react-router-dom";
import {EndpointError} from "../EndpointError";

const UserAccountIssues = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { data, status, error } = useClientAccountOverview();

    return (
        <>
            {status === "error" && (
                <EndpointError {...error} />
            )}

            <div className={`account-issues-container account-issue-highlight mt-n-sm ${(status !== 'loading' && status !== 'error') && (data?.counts?.lockedMailCount > 0 || data?.counts?.pendingStorageChargeCount > 0 || data?.counts?.actionRequiredBatchCount > 0) ? 'show-issues' : ''}`}>
                {status !== 'loading' && status !== "error" && (
                    <h6 className={'m-0 pb-xs pageantry-sub-heading'}>
                        {t('accountIssues.title', { count: data?.counts?.lockedMailCount + data?.counts?.pendingStorageChargeCount + data?.counts?.actionRequiredBatchCount })}
                    </h6>
                )}

                <div className={'user-account-issues'}>
                    {status !== 'loading' && status !== "error" && (
                        <>
                            {data?.counts?.lockedMailCount > 0 && (
                                <Tile
                                    onClick={() => navigate('./mail/locked-items', { state: { folderId: 9, includeFolderAssigned: true }})}
                                    title={t('accountIssues.labels.lockedItems')}
                                    description={t('accountIssues.counts.item', { count: data?.counts?.lockedMailCount })}
                                    icon={faLock}
                                    isHorizontal={true}
                                    colour={ColourSolid.Alert}
                                />
                            )}

                            {data?.counts?.pendingStorageChargeCount > 0 && (
                                <Tile
                                    onClick={() => navigate('./mail/locked-items', { state: { folderId: 9, includeFolderAssigned: true }})}
                                    title={t('accountIssues.labels.storageCharges')}
                                    description={t('accountIssues.counts.item', { count: data?.counts?.pendingStorageChargeCount })}
                                    icon={faInbox}
                                    isHorizontal={true}
                                    colour={ColourSolid.Alert}
                                />
                            )}

                            {data?.counts?.actionRequiredBatchCount > 0 && (
                                <Tile
                                    onClick={() => navigate('./mail/forwarding-batches', { state: { 'status': 1 }})}
                                    title={t('accountIssues.labels.forwardingBatches')}
                                    description={t('accountIssues.counts.batch', { count: data?.counts?.actionRequiredBatchCount })}
                                    icon={faShare}
                                    isHorizontal={true}
                                    colour={ColourSolid.Alert}
                                />
                            )}
                        </>
                    )}
                </div>
            </div>
        </>
    )
}

export { UserAccountIssues }
